const updateServicesConfirmationDialogStyle = () => ({
	textWrapper: {
		padding: '20px 0 35px 0',
	},
});

export default updateServicesConfirmationDialogStyle;
